import React, { useRef, useState } from "react";
import { Archive, Button, CheckCircle, Code02, DotsVertical, EyeOff, Link01, Menu, Modal } from "@opendate-app/setlist";
import { changeStatus, copyWithToast, embedCode, landingPageUrl } from "./membershipProductActions";

const MembershipHeaderActions = ({ product, teamId, csrfToken, hasChanges, busy, onPublish, onProductUpdate }) => {
  const [confirmArchive, setConfirmArchive] = useState(false);
  const [changing, setChanging] = useState(false);
  const inFlight = useRef(false);
  const published = product.status === "active";
  const draft = product.status === "draft";

  if (product.status === "archived") return null;

  const run = async (action) => {
    if (inFlight.current || busy) return;
    inFlight.current = true;
    setChanging(true);
    const updated = await changeStatus({ teamId, product, csrfToken, action });
    if (updated) onProductUpdate(updated);
    if (action === "archive" && updated) return;
    inFlight.current = false;
    setChanging(false);
    setConfirmArchive(false);
  };

  const items = [
    published && {
      key: "unpublish",
      label: "Unpublish membership",
      description: "Fans can't buy it. Current members keep their benefits.",
      icon: EyeOff,
      disabled: changing || busy,
      onClick: () => run("unpublish"),
    },
    {
      key: "link",
      label: "Copy landing page link",
      description: draft ? "Only your team can open this until it's published." : undefined,
      icon: Link01,
      onClick: () => copyWithToast(landingPageUrl(teamId, product), "Landing page link"),
    },
    {
      key: "embed",
      label: "Copy embed code",
      description: draft ? "Available once published." : undefined,
      icon: Code02,
      disabled: draft,
      onClick: () => copyWithToast(embedCode(teamId, product), "Embed code"),
    },
    { divider: true, key: "divider" },
    {
      key: "archive",
      label: "Archive membership…",
      icon: Archive,
      destructive: true,
      disabled: changing || busy,
      onClick: () => setConfirmArchive(true),
    },
  ].filter(Boolean);

  return (
    <div className="membership-header-actions">
      {draft ? (
        <Button variant="primary" icon={CheckCircle} disabled={busy || changing} onClick={onPublish}>
          {hasChanges ? "Save & publish" : "Publish"}
        </Button>
      ) : null}
      <Menu
        placement="bottom-end"
        items={items}
        trigger={<Button variant="secondary" icon={DotsVertical} aria-label="More actions" />}
      />
      <Modal
        open={confirmArchive}
        onClose={() => setConfirmArchive(false)}
        type="error"
        icon={Archive}
        title="Archive membership?"
        description={
          <>
            Archive <strong>{product.name}</strong>? Archived memberships will be removed from display.
          </>
        }
        cancelLabel="Cancel"
        onCancel={() => setConfirmArchive(false)}
        confirmLabel="Archive"
        onConfirm={() => run("archive")}
      />
    </div>
  );
};

export default MembershipHeaderActions;
